module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "intro-y flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('app-icon', {
    attrs: {
      "name": 'search',
      "classname": 'w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700'
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.name),
      expression: "filter.name"
    }],
    staticClass: "input w-full sm:w-64 box px-10 text-gray-700",
    attrs: {
      "type": "text",
      "placeholder": "Buscar por nombre"
    },
    domProps: {
      "value": (_vm.filter.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inbox-filter dropdown absolute inset-y-0 mr-3 right-0 flex items-center"
  }, [_c('app-icon', {
    attrs: {
      "name": 'chevron-down',
      "classname": 'dropdown-toggle w-4 h-4 cursor-pointer text-gray-700'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inbox-filter__dropdown-box dropdown-box mt-10 absolute top-0 left-0 z-20"
  }, [_c('div', {
    staticClass: "dropdown-box__content box p-5"
  }, [_c('div', {
    staticClass: "grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Cuenta")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.account),
      expression: "filter.account"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "account", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Seleccione la cuenta")]), _vm._v(" "), _vm._l((_vm.accounts), function(account) {
    return _c('option', {
      key: account.id,
      domProps: {
        "value": account.id
      }
    }, [_vm._v("\n                      " + _vm._s(account.name) + " - " + _vm._s(account.country.prefix) + "\n                    ")])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos")])], 2)])])])])], 1)], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.boxedit) ? _c('div', {
    staticClass: "intro-y box mt-6"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateHour.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Cuenta:")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.hour.account.name + ' - ' + _vm.hour.account.country.prefix
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Equipo:")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.hour.team.name
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Horas Por Semana:")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": _vm.hour.hours
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('hours', $event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeEditHour()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("Modificar")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "intro-y grid grid-cols-12 mt-5"
  }, _vm._l((_vm.filteredAccounts), function(account) {
    return _c('div', {
      staticClass: "col-span-12 sm:col-span-6 xxl:col-span-6 p-2"
    }, [_c('div', {
      staticClass: "pos__ticket box p-2 mt-5"
    }, [_c('span', {
      staticClass: "flex items-center p-3 transition duration-300 ease-in-out bg-theme-2 hover:bg-gray-200 rounded-md"
    }, [_c('div', {
      staticClass: "pos__ticket__item-name truncate mr-1"
    }, [_vm._v(_vm._s(account.name) + " - " + _vm._s(account.country.prefix))])]), _vm._v(" "), _vm._l((_vm.hours), function(hour) {
      return (hour.account_id === account.id) ? _c('a', {
        staticClass: "flex items-center p-3 cursor-pointer transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
        on: {
          "click": function($event) {
            return _vm.editHour(hour)
          }
        }
      }, [_c('div', {
        staticClass: "pos__ticket__item-name truncate mr-1"
      }, [_vm._v(_vm._s(hour.team.name))]), _vm._v(" "), _c('app-icon', {
        attrs: {
          "name": 'edit',
          "classname": 'w-4 h-4 mr-2'
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "text-xs text-gray-400"
      }, [_vm._v(_vm._s(hour.period.start_date) + " - " + _vm._s(hour.period.finish_date))]), _vm._v(" "), _c('div', {
        staticClass: "ml-auto"
      }, [_vm._v(_vm._s(hour.hours))])], 1) : _vm._e()
    })], 2)])
  }), 0)]) : _c('div', [_c('app-loading')], 1), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "hour"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--sm"
  }, [_vm._m(2), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createHour.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hour.account_id),
      expression: "hour.account_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.hour, "account_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione la cuenta")]), _vm._v(" "), _vm._l((_vm.accounts), function(account) {
    return _c('option', {
      domProps: {
        "value": account.id
      }
    }, [_vm._v("\n                    " + _vm._s(account.name) + " - " + _vm._s(account.country.prefix) + "\n                  ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Equipo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hour.team_id),
      expression: "hour.team_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.hour, "team_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el equipo")]), _vm._v(" "), _vm._l((_vm.teams), function(team) {
    return _c('option', {
      domProps: {
        "value": team.id
      }
    }, [_vm._v("\n                    " + _vm._s(team.name) + "\n                  ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Horas Por Semana:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hour.hours),
      expression: "hour.hours"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "number",
      "required": ""
    },
    domProps: {
      "value": (_vm.hour.hours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.hour, "hours", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(3)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('a', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "data-target": "#hour",
      "data-toggle": "modal"
    }
  }, [_vm._v("Crear Horas Soporte")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n            Editar Hora de Soporte\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n              Crear Horas de Soporte\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("Crear")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-528970de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/hour/ListHour.vue
// module id = 439
// module chunks = 1